// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__bmvaR","label":"Section_label__3DH5m","contentWrap":"Section_contentWrap__FNf21","footer":"Section_footer__2ND8u","footerInner":"Section_footerInner__GQE7q"};